import { render, staticRenderFns } from "./SimpleSankeyDiagram.vue?vue&type=template&id=e68bbb48&"
import script from "./SimpleSankeyDiagram.vue?vue&type=script&lang=js&"
export * from "./SimpleSankeyDiagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e68bbb48')) {
      api.createRecord('e68bbb48', component.options)
    } else {
      api.reload('e68bbb48', component.options)
    }
    module.hot.accept("./SimpleSankeyDiagram.vue?vue&type=template&id=e68bbb48&", function () {
      api.rerender('e68bbb48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Charts/SimpleSankeyDiagram.vue"
export default component.exports